export default {"src":"/_next/static/media/croissant.fd87d9d3.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};